import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import { DELETE_CATEGORY, GET_ALL_CATEGORIES } from '../gql/categories';

const CategoryDelete = ({ category, open, setOpen }) => {
  const [deleteCategory] = useMutation(DELETE_CATEGORY, {
    refetchQueries: [{ query: GET_ALL_CATEGORIES }],
    onCompleted() {
      setOpen(false);
    },
  });
  const { id, folderName } = category;

  const handleDelete = () => {
    deleteCategory({
      variables: { id },
    });
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="dialog-delete">
      <DialogTitle id="dialog-delete">Confrim Delete</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>This action CANNOT be reversed</Typography>
        <Typography gutterBottom>
          This will delete the folder and all the files inside, both
          upload&nbsp;&amp;&nbsp;sorted folder. If you just want to hide the
          file from this category, please change it&apos;s active state.
        </Typography>
        <Typography gutterBottom>
          Do you confrim to delete folder:&nbsp;
          {folderName}
          &#63;
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleDelete} color="primary">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CategoryDelete.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
    folderName: PropTypes.string.isRequired,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default CategoryDelete;
